import React from 'react'
import UserIcon from '../../Assets/Icons/userIcon.png';



const BoardFrameConsumer = ({ sortedData, rank }) => {

  const trimName = (name) => {
    if (!name) return '';
    return name.split(' ').slice(0, 2).join(' ');
  };
  return (
    <div>

      <div className='h-[90px] px-5 mb-4 flex justify-between items-center bg-[#F7F9F9]'>
        <div className='flex items-center gap-1'>
          <div>
            <img src={UserIcon} alt='user' className='w-[40px] h-[40px]' />
          </div>
          <div className='flex flex-col'>
            <span className='ml-2 text-[14px]'>You</span>
            <span className='ml-2 text-[14px]'>Latest Rank</span>
          </div>
        </div>
        <div>
          <p className='w-10 rounded-xl bg-[#0077CF] text-white text-center shadow-custom' >{rank}</p>
        </div>
      </div>
      {sortedData?.map((user, index) => (
        <div key={index} className='flex flex-row justify-between items-center mb-2 border-b border-[#ebebeb] px-5'>
          <div className='flex items-center gap-4'>
            <div>
              <img src={UserIcon} alt='user' className='w-[40px] h-[40px]' />
            </div>
            <span className='ml-2 text-[14px]'>{trimName(user.UserName)}</span>
          </div>

        </div>
      ))}
    </div>
  )
}

export default BoardFrameConsumer
